import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const memberListRoutes = {
  path: 'member-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.member.list'),
  },
  children: [
    {
      path: '',
      name: 'memberList',
      component: () => lazyLoadView(import('@views/MemberList/list.vue')),
      mete: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: 'registration',
      name: 'memberRegistration',
      component: () =>
        lazyLoadView(import('@views/MemberList/registration.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.member.add'),
      },
    },
    {
      path: 'edit/:id/:agent_id',
      name: 'editMember',
      component: () => lazyLoadView(import('@views/MemberList/edit.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.member.edit'),
      },
    },
    {
      path: 'detail/:id/:agent_id',
      name: 'memberDetail',
      component: () => lazyLoadView(import('@views/MemberList/detail.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.member.detail'),
      },
    },
  ],
}

export default memberListRoutes
